import './index.css'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { initI18n } from '@rs/ui/i18n'
import { App } from './app/router.tsx'

const el = document.getElementById('root')
if (!el) throw new Error('Không tìm thấy #root')

/**
 * ⚠ VẼ SAU KHI i18next XONG — không vẽ trước rồi vá sau.
 * Kho chuỗi nạp trễ (Task 21): nhóm khoá khởi động (`common · nav · login · roles`) là các chunk
 * riêng. Vẽ trước khi chúng về thì `t()` gặp khoá chưa có ⇒ `missingKeyHandler` NÉM ở dev, còn ở
 * production sidebar hiện một nhịp khoá thô rồi mới đổi thành nhãn — nháy chữ trước mắt người dùng.
 *
 * Dùng `.then()` chứ không `await` cấp mô-đun: `await` cấp mô-đun buộc Vite/Rollup dựng gói theo
 * kiểu khác và ràng thêm điều kiện về trình duyệt đích, đổi lại không được gì ở đây.
 *
 * Không có nhánh `.catch`: kho chuỗi tải hỏng thì màn hình trống + lỗi đỏ trong console là ĐÚNG
 * hành vi cần — vẽ một giao diện toàn khoá thô cho kế toán thao tác mới là cái tệ hơn.
 */
void initI18n().then(() => {
  createRoot(el).render(
    <StrictMode>
      <App />
    </StrictMode>,
  )
})
